import VFocus from './VFocus';

export default [
  VFocus
];
